import { render, staticRenderFns } from "./RedisCacheManagementDialog.vue?vue&type=template&id=d86480c8&"
import script from "./RedisCacheManagementDialog.vue?vue&type=script&lang=ts&"
export * from "./RedisCacheManagementDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports